"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPart = exports.hasPart = exports.getExact = exports.hasExact = void 0;
// This file is auto-generated. Modify the script that creates it.
var _48_1 = require("./Exact/48");
var _49_1 = require("./Exact/49");
var _52_1 = require("./Exact/52");
var _97_1 = require("./Exact/97");
var _113_1 = require("./Exact/113");
var _101_1 = require("./Exact/101");
var _100_1 = require("./Exact/100");
var _103_1 = require("./Exact/103");
var _111_1 = require("./Exact/111");
var _110_1 = require("./Exact/110");
var _116_1 = require("./Exact/116");
var _112_1 = require("./Exact/112");
var _105_1 = require("./Exact/105");
var _117_1 = require("./Exact/117");
var _109_1 = require("./Exact/109");
var _107_1 = require("./Exact/107");
var _99_1 = require("./Exact/99");
var _98_1 = require("./Exact/98");
var _115_1 = require("./Exact/115");
var _119_1 = require("./Exact/119");
var _108_1 = require("./Exact/108");
var _114_1 = require("./Exact/114");
var _102_1 = require("./Exact/102");
var _118_1 = require("./Exact/118");
var _106_1 = require("./Exact/106");
var _45_1 = require("./Exact/45");
var _120_1 = require("./Exact/120");
var _225_1 = require("./Exact/225");
var _122_1 = require("./Exact/122");
var _121_1 = require("./Exact/121");
var _104_1 = require("./Exact/104");
var _1578_1 = require("./Exact/1578");
var _8217_1 = require("./Exact/8217");
var _382_1 = require("./Exact/382");
var _331_1 = require("./Exact/331");
var _616_1 = require("./Exact/616");
var _224_1 = require("./Exact/224");
var _236_1 = require("./Exact/236");
var _353_1 = require("./Exact/353");
var _1808_1 = require("./Exact/1808");
var _39_1 = require("./Exact/39");
var _4768_1 = require("./Exact/4768");
var _241_1 = require("./Exact/241");
var _246_1 = require("./Exact/246");
var _1588_1 = require("./Exact/1588");
var _1575_1 = require("./Exact/1575");
var _1593_1 = require("./Exact/1593");
var _2437_1 = require("./Exact/2437");
var _35_1 = require("./Exact/35");
var _235_1 = require("./Exact/235");
var _1576_1 = require("./Exact/1576");
var _227_1 = require("./Exact/227");
var _8211_1 = require("./Exact/8211");
var _7717_1 = require("./Exact/7717");
var _1072_1 = require("./Exact/1072");
var _1570_1 = require("./Exact/1570");
var _1583_1 = require("./Exact/1583");
var _595_1 = require("./Exact/595");
var _1073_1 = require("./Exact/1073");
var _700_1 = require("./Exact/700");
var _596_1 = require("./Exact/596");
var _4705_1 = require("./Exact/4705");
var _240_1 = require("./Exact/240");
var _42892_1 = require("./Exact/42892");
var _2476_1 = require("./Exact/2476");
var _3926_1 = require("./Exact/3926");
var _2348_1 = require("./Exact/2348");
var _4707_1 = require("./Exact/4707");
var _4709_1 = require("./Exact/4709");
var _55300_1 = require("./Exact/55300");
var _1085_1 = require("./Exact/1085");
var _322_1 = require("./Exact/322");
var _8216_1 = require("./Exact/8216");
var _239_1 = require("./Exact/239");
var _43955_1 = require("./Exact/43955");
var _1705_1 = require("./Exact/1705");
var _1606_1 = require("./Exact/1606");
var _269_1 = require("./Exact/269");
var _7869_1 = require("./Exact/7869");
var _252_1 = require("./Exact/252");
var _5312_1 = require("./Exact/5312");
var _5124_1 = require("./Exact/5124");
var _5130_1 = require("./Exact/5130");
var _299_1 = require("./Exact/299");
var _1094_1 = require("./Exact/1094");
var _2337_1 = require("./Exact/2337");
var _4876_1 = require("./Exact/4876");
var _2342_1 = require("./Exact/2342");
var _1931_1 = require("./Exact/1931");
var _3938_1 = require("./Exact/3938");
var _233_1 = require("./Exact/233");
var _949_1 = require("./Exact/949");
var _1601_1 = require("./Exact/1601");
var _55354_1 = require("./Exact/55354");
var NaN_1 = require("./Exact/NaN");
var _1698_1 = require("./Exact/1698");
var _4877_1 = require("./Exact/4877");
var _1711_1 = require("./Exact/1711");
var _8225_1 = require("./Exact/8225");
var _449_1 = require("./Exact/449");
var _450_1 = require("./Exact/450");
var _234_1 = require("./Exact/234");
var _47_1 = require("./Exact/47");
var _2711_1 = require("./Exact/2711");
var _448_1 = require("./Exact/448");
var _699_1 = require("./Exact/699");
var _1506_1 = require("./Exact/1506");
var _2361_1 = require("./Exact/2361");
var _1729_1 = require("./Exact/1729");
var _257_1 = require("./Exact/257");
var _333_1 = require("./Exact/333");
var _1392_1 = require("./Exact/1392");
var _237_1 = require("./Exact/237");
var _41352_1 = require("./Exact/41352");
var _7883_1 = require("./Exact/7883");
var _7885_1 = require("./Exact/7885");
var _5123_1 = require("./Exact/5123");
var _26085_1 = require("./Exact/26085");
var _232_1 = require("./Exact/232");
var _4325_1 = require("./Exact/4325");
var _249_1 = require("./Exact/249");
var _3221_1 = require("./Exact/3221");
var _3093_1 = require("./Exact/3093");
var _6533_1 = require("./Exact/6533");
var _91_1 = require("./Exact/91");
var _1179_1 = require("./Exact/1179");
var _1090_1 = require("./Exact/1090");
var _228_1 = require("./Exact/228");
var _6017_1 = require("./Exact/6017");
var _33_1 = require("./Exact/33");
var _54620_1 = require("./Exact/54620");
var _2325_1 = require("./Exact/2325");
var _1662_1 = require("./Exact/1662");
var _599_1 = require("./Exact/599");
var _238_1 = require("./Exact/238");
var _1082_1 = require("./Exact/1082");
var _43274_1 = require("./Exact/43274");
var _289_1 = require("./Exact/289");
var _487_1 = require("./Exact/487");
var _3939_1 = require("./Exact/3939");
var _2351_1 = require("./Exact/2351");
var _42209_1 = require("./Exact/42209");
var _3749_1 = require("./Exact/3749");
var _2354_1 = require("./Exact/2354");
var _1604_1 = require("./Exact/1604");
var _243_1 = require("./Exact/243");
var _7789_1 = require("./Exact/7789");
var _2350_1 = require("./Exact/2350");
var _244_1 = require("./Exact/244");
var _1084_1 = require("./Exact/1084");
var _3374_1 = require("./Exact/3374");
var _2478_1 = require("./Exact/2478");
var _660_1 = require("./Exact/660");
var _1605_1 = require("./Exact/1605");
var _4121_1 = require("./Exact/4121");
var _2344_1 = require("./Exact/2344");
var _451_1 = require("./Exact/451");
var _3588_1 = require("./Exact/3588");
var _601_1 = require("./Exact/601");
var _2835_1 = require("./Exact/2835");
var _1080_1 = require("./Exact/1080");
var _7695_1 = require("./Exact/7695");
var _2602_1 = require("./Exact/2602");
var _2986_1 = require("./Exact/2986");
var _263_1 = require("./Exact/263");
var _1088_1 = require("./Exact/1088");
var _2360_1 = require("./Exact/2360");
var _1089_1 = require("./Exact/1089");
var _7269_1 = require("./Exact/7269");
var _1587_1 = require("./Exact/1587");
var _4656_1 = require("./Exact/4656");
var _4708_1 = require("./Exact/4708");
var _4873_1 = require("./Exact/4873");
var _11612_1 = require("./Exact/11612");
var _4124_1 = require("./Exact/4124");
var _1607_1 = require("./Exact/1607");
var _3523_1 = require("./Exact/3523");
var _229_1 = require("./Exact/229");
var _297_1 = require("./Exact/297");
var _4840_1 = require("./Exact/4840");
var _2459_1 = require("./Exact/2459");
var _1827_1 = require("./Exact/1827");
var _347_1 = require("./Exact/347");
var _2980_1 = require("./Exact/2980");
var _2340_1 = require("./Exact/2340");
var _6486_1 = require("./Exact/6486");
var _3108_1 = require("./Exact/3108");
var _3652_1 = require("./Exact/3652");
var _4725_1 = require("./Exact/4725");
var _417_1 = require("./Exact/417");
var _273_1 = require("./Exact/273");
var _1574_1 = require("./Exact/1574");
var _1091_1 = require("./Exact/1091");
var _1118_1 = require("./Exact/1118");
var _42329_1 = require("./Exact/42329");
var _4808_1 = require("./Exact/4808");
var _2358_1 = require("./Exact/2358");
var _1497_1 = require("./Exact/1497");
var _31925_1 = require("./Exact/31925");
var _31908_1 = require("./Exact/31908");
var _20013_1 = require("./Exact/20013");
var _32321_1 = require("./Exact/32321");
exports.hasExact = function (key) {
    if (!key || key.length === 0)
        return false;
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 48: return _48_1.f48.hasOwnProperty(key);
        case 49: return _49_1.f49.hasOwnProperty(key);
        case 52: return _52_1.f52.hasOwnProperty(key);
        case 97: return _97_1.f97.hasOwnProperty(key);
        case 113: return _113_1.f113.hasOwnProperty(key);
        case 101: return _101_1.f101.hasOwnProperty(key);
        case 100: return _100_1.f100.hasOwnProperty(key);
        case 103: return _103_1.f103.hasOwnProperty(key);
        case 111: return _111_1.f111.hasOwnProperty(key);
        case 110: return _110_1.f110.hasOwnProperty(key);
        case 116: return _116_1.f116.hasOwnProperty(key);
        case 112: return _112_1.f112.hasOwnProperty(key);
        case 105: return _105_1.f105.hasOwnProperty(key);
        case 117: return _117_1.f117.hasOwnProperty(key);
        case 109: return _109_1.f109.hasOwnProperty(key);
        case 107: return _107_1.f107.hasOwnProperty(key);
        case 99: return _99_1.f99.hasOwnProperty(key);
        case 98: return _98_1.f98.hasOwnProperty(key);
        case 115: return _115_1.f115.hasOwnProperty(key);
        case 119: return _119_1.f119.hasOwnProperty(key);
        case 108: return _108_1.f108.hasOwnProperty(key);
        case 114: return _114_1.f114.hasOwnProperty(key);
        case 102: return _102_1.f102.hasOwnProperty(key);
        case 118: return _118_1.f118.hasOwnProperty(key);
        case 106: return _106_1.f106.hasOwnProperty(key);
        case 45: return _45_1.f45.hasOwnProperty(key);
        case 120: return _120_1.f120.hasOwnProperty(key);
        case 225: return _225_1.f225.hasOwnProperty(key);
        case 122: return _122_1.f122.hasOwnProperty(key);
        case 121: return _121_1.f121.hasOwnProperty(key);
        case 104: return _104_1.f104.hasOwnProperty(key);
        case 1578: return _1578_1.f1578.hasOwnProperty(key);
        case 8217: return _8217_1.f8217.hasOwnProperty(key);
        case 382: return _382_1.f382.hasOwnProperty(key);
        case 331: return _331_1.f331.hasOwnProperty(key);
        case 616: return _616_1.f616.hasOwnProperty(key);
        case 224: return _224_1.f224.hasOwnProperty(key);
        case 236: return _236_1.f236.hasOwnProperty(key);
        case 353: return _353_1.f353.hasOwnProperty(key);
        case 1808: return _1808_1.f1808.hasOwnProperty(key);
        case 39: return _39_1.f39.hasOwnProperty(key);
        case 4768: return _4768_1.f4768.hasOwnProperty(key);
        case 241: return _241_1.f241.hasOwnProperty(key);
        case 246: return _246_1.f246.hasOwnProperty(key);
        case 1588: return _1588_1.f1588.hasOwnProperty(key);
        case 1575: return _1575_1.f1575.hasOwnProperty(key);
        case 1593: return _1593_1.f1593.hasOwnProperty(key);
        case 2437: return _2437_1.f2437.hasOwnProperty(key);
        case 35: return _35_1.f35.hasOwnProperty(key);
        case 235: return _235_1.f235.hasOwnProperty(key);
        case 1576: return _1576_1.f1576.hasOwnProperty(key);
        case 227: return _227_1.f227.hasOwnProperty(key);
        case 8211: return _8211_1.f8211.hasOwnProperty(key);
        case 7717: return _7717_1.f7717.hasOwnProperty(key);
        case 1072: return _1072_1.f1072.hasOwnProperty(key);
        case 1570: return _1570_1.f1570.hasOwnProperty(key);
        case 1583: return _1583_1.f1583.hasOwnProperty(key);
        case 595: return _595_1.f595.hasOwnProperty(key);
        case 1073: return _1073_1.f1073.hasOwnProperty(key);
        case 700: return _700_1.f700.hasOwnProperty(key);
        case 596: return _596_1.f596.hasOwnProperty(key);
        case 4705: return _4705_1.f4705.hasOwnProperty(key);
        case 240: return _240_1.f240.hasOwnProperty(key);
        case 42892: return _42892_1.f42892.hasOwnProperty(key);
        case 2476: return _2476_1.f2476.hasOwnProperty(key);
        case 3926: return _3926_1.f3926.hasOwnProperty(key);
        case 2348: return _2348_1.f2348.hasOwnProperty(key);
        case 4707: return _4707_1.f4707.hasOwnProperty(key);
        case 4709: return _4709_1.f4709.hasOwnProperty(key);
        case 55300: return _55300_1.f55300.hasOwnProperty(key);
        case 1085: return _1085_1.f1085.hasOwnProperty(key);
        case 322: return _322_1.f322.hasOwnProperty(key);
        case 8216: return _8216_1.f8216.hasOwnProperty(key);
        case 239: return _239_1.f239.hasOwnProperty(key);
        case 43955: return _43955_1.f43955.hasOwnProperty(key);
        case 1705: return _1705_1.f1705.hasOwnProperty(key);
        case 1606: return _1606_1.f1606.hasOwnProperty(key);
        case 269: return _269_1.f269.hasOwnProperty(key);
        case 7869: return _7869_1.f7869.hasOwnProperty(key);
        case 252: return _252_1.f252.hasOwnProperty(key);
        case 5312: return _5312_1.f5312.hasOwnProperty(key);
        case 5124: return _5124_1.f5124.hasOwnProperty(key);
        case 5130: return _5130_1.f5130.hasOwnProperty(key);
        case 299: return _299_1.f299.hasOwnProperty(key);
        case 1094: return _1094_1.f1094.hasOwnProperty(key);
        case 2337: return _2337_1.f2337.hasOwnProperty(key);
        case 4876: return _4876_1.f4876.hasOwnProperty(key);
        case 2342: return _2342_1.f2342.hasOwnProperty(key);
        case 1931: return _1931_1.f1931.hasOwnProperty(key);
        case 3938: return _3938_1.f3938.hasOwnProperty(key);
        case 233: return _233_1.f233.hasOwnProperty(key);
        case 949: return _949_1.f949.hasOwnProperty(key);
        case 1601: return _1601_1.f1601.hasOwnProperty(key);
        case 55354: return _55354_1.f55354.hasOwnProperty(key);
        case NaN: return NaN_1.fNaN.hasOwnProperty(key);
        case 1698: return _1698_1.f1698.hasOwnProperty(key);
        case 4877: return _4877_1.f4877.hasOwnProperty(key);
        case 1711: return _1711_1.f1711.hasOwnProperty(key);
        case 8225: return _8225_1.f8225.hasOwnProperty(key);
        case 449: return _449_1.f449.hasOwnProperty(key);
        case 450: return _450_1.f450.hasOwnProperty(key);
        case 234: return _234_1.f234.hasOwnProperty(key);
        case 47: return _47_1.f47.hasOwnProperty(key);
        case 2711: return _2711_1.f2711.hasOwnProperty(key);
        case 448: return _448_1.f448.hasOwnProperty(key);
        case 699: return _699_1.f699.hasOwnProperty(key);
        case 1506: return _1506_1.f1506.hasOwnProperty(key);
        case 2361: return _2361_1.f2361.hasOwnProperty(key);
        case 1729: return _1729_1.f1729.hasOwnProperty(key);
        case 257: return _257_1.f257.hasOwnProperty(key);
        case 333: return _333_1.f333.hasOwnProperty(key);
        case 1392: return _1392_1.f1392.hasOwnProperty(key);
        case 237: return _237_1.f237.hasOwnProperty(key);
        case 41352: return _41352_1.f41352.hasOwnProperty(key);
        case 7883: return _7883_1.f7883.hasOwnProperty(key);
        case 7885: return _7885_1.f7885.hasOwnProperty(key);
        case 5123: return _5123_1.f5123.hasOwnProperty(key);
        case 26085: return _26085_1.f26085.hasOwnProperty(key);
        case 232: return _232_1.f232.hasOwnProperty(key);
        case 4325: return _4325_1.f4325.hasOwnProperty(key);
        case 249: return _249_1.f249.hasOwnProperty(key);
        case 3221: return _3221_1.f3221.hasOwnProperty(key);
        case 3093: return _3093_1.f3093.hasOwnProperty(key);
        case 6533: return _6533_1.f6533.hasOwnProperty(key);
        case 91: return _91_1.f91.hasOwnProperty(key);
        case 1179: return _1179_1.f1179.hasOwnProperty(key);
        case 1090: return _1090_1.f1090.hasOwnProperty(key);
        case 228: return _228_1.f228.hasOwnProperty(key);
        case 6017: return _6017_1.f6017.hasOwnProperty(key);
        case 33: return _33_1.f33.hasOwnProperty(key);
        case 54620: return _54620_1.f54620.hasOwnProperty(key);
        case 2325: return _2325_1.f2325.hasOwnProperty(key);
        case 1662: return _1662_1.f1662.hasOwnProperty(key);
        case 599: return _599_1.f599.hasOwnProperty(key);
        case 238: return _238_1.f238.hasOwnProperty(key);
        case 1082: return _1082_1.f1082.hasOwnProperty(key);
        case 43274: return _43274_1.f43274.hasOwnProperty(key);
        case 289: return _289_1.f289.hasOwnProperty(key);
        case 487: return _487_1.f487.hasOwnProperty(key);
        case 3939: return _3939_1.f3939.hasOwnProperty(key);
        case 2351: return _2351_1.f2351.hasOwnProperty(key);
        case 42209: return _42209_1.f42209.hasOwnProperty(key);
        case 3749: return _3749_1.f3749.hasOwnProperty(key);
        case 2354: return _2354_1.f2354.hasOwnProperty(key);
        case 1604: return _1604_1.f1604.hasOwnProperty(key);
        case 243: return _243_1.f243.hasOwnProperty(key);
        case 7789: return _7789_1.f7789.hasOwnProperty(key);
        case 2350: return _2350_1.f2350.hasOwnProperty(key);
        case 244: return _244_1.f244.hasOwnProperty(key);
        case 1084: return _1084_1.f1084.hasOwnProperty(key);
        case 3374: return _3374_1.f3374.hasOwnProperty(key);
        case 2478: return _2478_1.f2478.hasOwnProperty(key);
        case 660: return _660_1.f660.hasOwnProperty(key);
        case 1605: return _1605_1.f1605.hasOwnProperty(key);
        case 4121: return _4121_1.f4121.hasOwnProperty(key);
        case 2344: return _2344_1.f2344.hasOwnProperty(key);
        case 451: return _451_1.f451.hasOwnProperty(key);
        case 3588: return _3588_1.f3588.hasOwnProperty(key);
        case 601: return _601_1.f601.hasOwnProperty(key);
        case 2835: return _2835_1.f2835.hasOwnProperty(key);
        case 1080: return _1080_1.f1080.hasOwnProperty(key);
        case 7695: return _7695_1.f7695.hasOwnProperty(key);
        case 2602: return _2602_1.f2602.hasOwnProperty(key);
        case 2986: return _2986_1.f2986.hasOwnProperty(key);
        case 263: return _263_1.f263.hasOwnProperty(key);
        case 1088: return _1088_1.f1088.hasOwnProperty(key);
        case 2360: return _2360_1.f2360.hasOwnProperty(key);
        case 1089: return _1089_1.f1089.hasOwnProperty(key);
        case 7269: return _7269_1.f7269.hasOwnProperty(key);
        case 1587: return _1587_1.f1587.hasOwnProperty(key);
        case 4656: return _4656_1.f4656.hasOwnProperty(key);
        case 4708: return _4708_1.f4708.hasOwnProperty(key);
        case 4873: return _4873_1.f4873.hasOwnProperty(key);
        case 11612: return _11612_1.f11612.hasOwnProperty(key);
        case 4124: return _4124_1.f4124.hasOwnProperty(key);
        case 1607: return _1607_1.f1607.hasOwnProperty(key);
        case 3523: return _3523_1.f3523.hasOwnProperty(key);
        case 229: return _229_1.f229.hasOwnProperty(key);
        case 297: return _297_1.f297.hasOwnProperty(key);
        case 4840: return _4840_1.f4840.hasOwnProperty(key);
        case 2459: return _2459_1.f2459.hasOwnProperty(key);
        case 1827: return _1827_1.f1827.hasOwnProperty(key);
        case 347: return _347_1.f347.hasOwnProperty(key);
        case 2980: return _2980_1.f2980.hasOwnProperty(key);
        case 2340: return _2340_1.f2340.hasOwnProperty(key);
        case 6486: return _6486_1.f6486.hasOwnProperty(key);
        case 3108: return _3108_1.f3108.hasOwnProperty(key);
        case 3652: return _3652_1.f3652.hasOwnProperty(key);
        case 4725: return _4725_1.f4725.hasOwnProperty(key);
        case 417: return _417_1.f417.hasOwnProperty(key);
        case 273: return _273_1.f273.hasOwnProperty(key);
        case 1574: return _1574_1.f1574.hasOwnProperty(key);
        case 1091: return _1091_1.f1091.hasOwnProperty(key);
        case 1118: return _1118_1.f1118.hasOwnProperty(key);
        case 42329: return _42329_1.f42329.hasOwnProperty(key);
        case 4808: return _4808_1.f4808.hasOwnProperty(key);
        case 2358: return _2358_1.f2358.hasOwnProperty(key);
        case 1497: return _1497_1.f1497.hasOwnProperty(key);
        case 31925: return _31925_1.f31925.hasOwnProperty(key);
        case 31908: return _31908_1.f31908.hasOwnProperty(key);
        case 20013: return _20013_1.f20013.hasOwnProperty(key);
        case 32321: return _32321_1.f32321.hasOwnProperty(key);
        default: return false;
    }
};
exports.getExact = function (key) {
    if (!key || key.length === 0)
        return [];
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 48: return _48_1.f48[key];
        case 49: return _49_1.f49[key];
        case 52: return _52_1.f52[key];
        case 97: return _97_1.f97[key];
        case 113: return _113_1.f113[key];
        case 101: return _101_1.f101[key];
        case 100: return _100_1.f100[key];
        case 103: return _103_1.f103[key];
        case 111: return _111_1.f111[key];
        case 110: return _110_1.f110[key];
        case 116: return _116_1.f116[key];
        case 112: return _112_1.f112[key];
        case 105: return _105_1.f105[key];
        case 117: return _117_1.f117[key];
        case 109: return _109_1.f109[key];
        case 107: return _107_1.f107[key];
        case 99: return _99_1.f99[key];
        case 98: return _98_1.f98[key];
        case 115: return _115_1.f115[key];
        case 119: return _119_1.f119[key];
        case 108: return _108_1.f108[key];
        case 114: return _114_1.f114[key];
        case 102: return _102_1.f102[key];
        case 118: return _118_1.f118[key];
        case 106: return _106_1.f106[key];
        case 45: return _45_1.f45[key];
        case 120: return _120_1.f120[key];
        case 225: return _225_1.f225[key];
        case 122: return _122_1.f122[key];
        case 121: return _121_1.f121[key];
        case 104: return _104_1.f104[key];
        case 1578: return _1578_1.f1578[key];
        case 8217: return _8217_1.f8217[key];
        case 382: return _382_1.f382[key];
        case 331: return _331_1.f331[key];
        case 616: return _616_1.f616[key];
        case 224: return _224_1.f224[key];
        case 236: return _236_1.f236[key];
        case 353: return _353_1.f353[key];
        case 1808: return _1808_1.f1808[key];
        case 39: return _39_1.f39[key];
        case 4768: return _4768_1.f4768[key];
        case 241: return _241_1.f241[key];
        case 246: return _246_1.f246[key];
        case 1588: return _1588_1.f1588[key];
        case 1575: return _1575_1.f1575[key];
        case 1593: return _1593_1.f1593[key];
        case 2437: return _2437_1.f2437[key];
        case 35: return _35_1.f35[key];
        case 235: return _235_1.f235[key];
        case 1576: return _1576_1.f1576[key];
        case 227: return _227_1.f227[key];
        case 8211: return _8211_1.f8211[key];
        case 7717: return _7717_1.f7717[key];
        case 1072: return _1072_1.f1072[key];
        case 1570: return _1570_1.f1570[key];
        case 1583: return _1583_1.f1583[key];
        case 595: return _595_1.f595[key];
        case 1073: return _1073_1.f1073[key];
        case 700: return _700_1.f700[key];
        case 596: return _596_1.f596[key];
        case 4705: return _4705_1.f4705[key];
        case 240: return _240_1.f240[key];
        case 42892: return _42892_1.f42892[key];
        case 2476: return _2476_1.f2476[key];
        case 3926: return _3926_1.f3926[key];
        case 2348: return _2348_1.f2348[key];
        case 4707: return _4707_1.f4707[key];
        case 4709: return _4709_1.f4709[key];
        case 55300: return _55300_1.f55300[key];
        case 1085: return _1085_1.f1085[key];
        case 322: return _322_1.f322[key];
        case 8216: return _8216_1.f8216[key];
        case 239: return _239_1.f239[key];
        case 43955: return _43955_1.f43955[key];
        case 1705: return _1705_1.f1705[key];
        case 1606: return _1606_1.f1606[key];
        case 269: return _269_1.f269[key];
        case 7869: return _7869_1.f7869[key];
        case 252: return _252_1.f252[key];
        case 5312: return _5312_1.f5312[key];
        case 5124: return _5124_1.f5124[key];
        case 5130: return _5130_1.f5130[key];
        case 299: return _299_1.f299[key];
        case 1094: return _1094_1.f1094[key];
        case 2337: return _2337_1.f2337[key];
        case 4876: return _4876_1.f4876[key];
        case 2342: return _2342_1.f2342[key];
        case 1931: return _1931_1.f1931[key];
        case 3938: return _3938_1.f3938[key];
        case 233: return _233_1.f233[key];
        case 949: return _949_1.f949[key];
        case 1601: return _1601_1.f1601[key];
        case 55354: return _55354_1.f55354[key];
        case NaN: return NaN_1.fNaN[key];
        case 1698: return _1698_1.f1698[key];
        case 4877: return _4877_1.f4877[key];
        case 1711: return _1711_1.f1711[key];
        case 8225: return _8225_1.f8225[key];
        case 449: return _449_1.f449[key];
        case 450: return _450_1.f450[key];
        case 234: return _234_1.f234[key];
        case 47: return _47_1.f47[key];
        case 2711: return _2711_1.f2711[key];
        case 448: return _448_1.f448[key];
        case 699: return _699_1.f699[key];
        case 1506: return _1506_1.f1506[key];
        case 2361: return _2361_1.f2361[key];
        case 1729: return _1729_1.f1729[key];
        case 257: return _257_1.f257[key];
        case 333: return _333_1.f333[key];
        case 1392: return _1392_1.f1392[key];
        case 237: return _237_1.f237[key];
        case 41352: return _41352_1.f41352[key];
        case 7883: return _7883_1.f7883[key];
        case 7885: return _7885_1.f7885[key];
        case 5123: return _5123_1.f5123[key];
        case 26085: return _26085_1.f26085[key];
        case 232: return _232_1.f232[key];
        case 4325: return _4325_1.f4325[key];
        case 249: return _249_1.f249[key];
        case 3221: return _3221_1.f3221[key];
        case 3093: return _3093_1.f3093[key];
        case 6533: return _6533_1.f6533[key];
        case 91: return _91_1.f91[key];
        case 1179: return _1179_1.f1179[key];
        case 1090: return _1090_1.f1090[key];
        case 228: return _228_1.f228[key];
        case 6017: return _6017_1.f6017[key];
        case 33: return _33_1.f33[key];
        case 54620: return _54620_1.f54620[key];
        case 2325: return _2325_1.f2325[key];
        case 1662: return _1662_1.f1662[key];
        case 599: return _599_1.f599[key];
        case 238: return _238_1.f238[key];
        case 1082: return _1082_1.f1082[key];
        case 43274: return _43274_1.f43274[key];
        case 289: return _289_1.f289[key];
        case 487: return _487_1.f487[key];
        case 3939: return _3939_1.f3939[key];
        case 2351: return _2351_1.f2351[key];
        case 42209: return _42209_1.f42209[key];
        case 3749: return _3749_1.f3749[key];
        case 2354: return _2354_1.f2354[key];
        case 1604: return _1604_1.f1604[key];
        case 243: return _243_1.f243[key];
        case 7789: return _7789_1.f7789[key];
        case 2350: return _2350_1.f2350[key];
        case 244: return _244_1.f244[key];
        case 1084: return _1084_1.f1084[key];
        case 3374: return _3374_1.f3374[key];
        case 2478: return _2478_1.f2478[key];
        case 660: return _660_1.f660[key];
        case 1605: return _1605_1.f1605[key];
        case 4121: return _4121_1.f4121[key];
        case 2344: return _2344_1.f2344[key];
        case 451: return _451_1.f451[key];
        case 3588: return _3588_1.f3588[key];
        case 601: return _601_1.f601[key];
        case 2835: return _2835_1.f2835[key];
        case 1080: return _1080_1.f1080[key];
        case 7695: return _7695_1.f7695[key];
        case 2602: return _2602_1.f2602[key];
        case 2986: return _2986_1.f2986[key];
        case 263: return _263_1.f263[key];
        case 1088: return _1088_1.f1088[key];
        case 2360: return _2360_1.f2360[key];
        case 1089: return _1089_1.f1089[key];
        case 7269: return _7269_1.f7269[key];
        case 1587: return _1587_1.f1587[key];
        case 4656: return _4656_1.f4656[key];
        case 4708: return _4708_1.f4708[key];
        case 4873: return _4873_1.f4873[key];
        case 11612: return _11612_1.f11612[key];
        case 4124: return _4124_1.f4124[key];
        case 1607: return _1607_1.f1607[key];
        case 3523: return _3523_1.f3523[key];
        case 229: return _229_1.f229[key];
        case 297: return _297_1.f297[key];
        case 4840: return _4840_1.f4840[key];
        case 2459: return _2459_1.f2459[key];
        case 1827: return _1827_1.f1827[key];
        case 347: return _347_1.f347[key];
        case 2980: return _2980_1.f2980[key];
        case 2340: return _2340_1.f2340[key];
        case 6486: return _6486_1.f6486[key];
        case 3108: return _3108_1.f3108[key];
        case 3652: return _3652_1.f3652[key];
        case 4725: return _4725_1.f4725[key];
        case 417: return _417_1.f417[key];
        case 273: return _273_1.f273[key];
        case 1574: return _1574_1.f1574[key];
        case 1091: return _1091_1.f1091[key];
        case 1118: return _1118_1.f1118[key];
        case 42329: return _42329_1.f42329[key];
        case 4808: return _4808_1.f4808[key];
        case 2358: return _2358_1.f2358[key];
        case 1497: return _1497_1.f1497[key];
        case 31925: return _31925_1.f31925[key];
        case 31908: return _31908_1.f31908[key];
        case 20013: return _20013_1.f20013[key];
        case 32321: return _32321_1.f32321[key];
        default: return [];
    }
};
exports.hasPart = function (key) {
    if (!key || key.length === 0)
        return false;
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 48: return true;
        case 49: return true;
        case 52: return true;
        case 97: return true;
        case 113: return true;
        case 101: return true;
        case 100: return true;
        case 103: return true;
        case 111: return true;
        case 110: return true;
        case 116: return true;
        case 112: return true;
        case 105: return true;
        case 117: return true;
        case 109: return true;
        case 107: return true;
        case 99: return true;
        case 98: return true;
        case 115: return true;
        case 119: return true;
        case 108: return true;
        case 114: return true;
        case 102: return true;
        case 118: return true;
        case 106: return true;
        case 45: return true;
        case 120: return true;
        case 225: return true;
        case 122: return true;
        case 121: return true;
        case 104: return true;
        case 1578: return true;
        case 8217: return true;
        case 382: return true;
        case 331: return true;
        case 616: return true;
        case 224: return true;
        case 236: return true;
        case 353: return true;
        case 1808: return true;
        case 39: return true;
        case 4768: return true;
        case 241: return true;
        case 246: return true;
        case 1588: return true;
        case 1575: return true;
        case 1593: return true;
        case 2437: return true;
        case 35: return true;
        case 235: return true;
        case 1576: return true;
        case 227: return true;
        case 8211: return true;
        case 7717: return true;
        case 1072: return true;
        case 1570: return true;
        case 1583: return true;
        case 595: return true;
        case 1073: return true;
        case 700: return true;
        case 596: return true;
        case 4705: return true;
        case 240: return true;
        case 42892: return true;
        case 2476: return true;
        case 3926: return true;
        case 2348: return true;
        case 4707: return true;
        case 4709: return true;
        case 55300: return true;
        case 1085: return true;
        case 322: return true;
        case 8216: return true;
        case 239: return true;
        case 43955: return true;
        case 1705: return true;
        case 1606: return true;
        case 269: return true;
        case 7869: return true;
        case 252: return true;
        case 5312: return true;
        case 5124: return true;
        case 5130: return true;
        case 299: return true;
        case 1094: return true;
        case 2337: return true;
        case 4876: return true;
        case 2342: return true;
        case 1931: return true;
        case 3938: return true;
        case 233: return true;
        case 949: return true;
        case 1601: return true;
        case 55354: return true;
        case NaN: return true;
        case 1698: return true;
        case 4877: return true;
        case 1711: return true;
        case 8225: return true;
        case 449: return true;
        case 450: return true;
        case 234: return true;
        case 47: return true;
        case 2711: return true;
        case 448: return true;
        case 699: return true;
        case 1506: return true;
        case 2361: return true;
        case 1729: return true;
        case 257: return true;
        case 333: return true;
        case 1392: return true;
        case 237: return true;
        case 41352: return true;
        case 7883: return true;
        case 7885: return true;
        case 5123: return true;
        case 26085: return true;
        case 232: return true;
        case 4325: return true;
        case 249: return true;
        case 3221: return true;
        case 3093: return true;
        case 6533: return true;
        case 91: return true;
        case 1179: return true;
        case 1090: return true;
        case 228: return true;
        case 6017: return true;
        case 33: return true;
        case 54620: return true;
        case 2325: return true;
        case 1662: return true;
        case 599: return true;
        case 238: return true;
        case 1082: return true;
        case 43274: return true;
        case 289: return true;
        case 487: return true;
        case 3939: return true;
        case 2351: return true;
        case 42209: return true;
        case 3749: return true;
        case 2354: return true;
        case 1604: return true;
        case 243: return true;
        case 7789: return true;
        case 2350: return true;
        case 244: return true;
        case 1084: return true;
        case 3374: return true;
        case 2478: return true;
        case 660: return true;
        case 1605: return true;
        case 4121: return true;
        case 2344: return true;
        case 451: return true;
        case 3588: return true;
        case 601: return true;
        case 2835: return true;
        case 1080: return true;
        case 7695: return true;
        case 2602: return true;
        case 2986: return true;
        case 263: return true;
        case 1088: return true;
        case 2360: return true;
        case 1089: return true;
        case 7269: return true;
        case 1587: return true;
        case 4656: return true;
        case 4708: return true;
        case 4873: return true;
        case 11612: return true;
        case 4124: return true;
        case 1607: return true;
        case 3523: return true;
        case 229: return true;
        case 297: return true;
        case 4840: return true;
        case 2459: return true;
        case 1827: return true;
        case 347: return true;
        case 2980: return true;
        case 2340: return true;
        case 6486: return true;
        case 3108: return true;
        case 3652: return true;
        case 4725: return true;
        case 417: return true;
        case 273: return true;
        case 1574: return true;
        case 1091: return true;
        case 1118: return true;
        case 42329: return true;
        case 4808: return true;
        case 2358: return true;
        case 1497: return true;
        case 31925: return true;
        case 31908: return true;
        case 20013: return true;
        case 32321: return true;
        default: return false;
    }
};
exports.getPart = function (key) {
    if (!key || key.length === 0)
        return [];
    switch (key.slice(0, 1).charCodeAt(0)) {
        case 48: return _48_1.f48;
        case 49: return _49_1.f49;
        case 52: return _52_1.f52;
        case 97: return _97_1.f97;
        case 113: return _113_1.f113;
        case 101: return _101_1.f101;
        case 100: return _100_1.f100;
        case 103: return _103_1.f103;
        case 111: return _111_1.f111;
        case 110: return _110_1.f110;
        case 116: return _116_1.f116;
        case 112: return _112_1.f112;
        case 105: return _105_1.f105;
        case 117: return _117_1.f117;
        case 109: return _109_1.f109;
        case 107: return _107_1.f107;
        case 99: return _99_1.f99;
        case 98: return _98_1.f98;
        case 115: return _115_1.f115;
        case 119: return _119_1.f119;
        case 108: return _108_1.f108;
        case 114: return _114_1.f114;
        case 102: return _102_1.f102;
        case 118: return _118_1.f118;
        case 106: return _106_1.f106;
        case 45: return _45_1.f45;
        case 120: return _120_1.f120;
        case 225: return _225_1.f225;
        case 122: return _122_1.f122;
        case 121: return _121_1.f121;
        case 104: return _104_1.f104;
        case 1578: return _1578_1.f1578;
        case 8217: return _8217_1.f8217;
        case 382: return _382_1.f382;
        case 331: return _331_1.f331;
        case 616: return _616_1.f616;
        case 224: return _224_1.f224;
        case 236: return _236_1.f236;
        case 353: return _353_1.f353;
        case 1808: return _1808_1.f1808;
        case 39: return _39_1.f39;
        case 4768: return _4768_1.f4768;
        case 241: return _241_1.f241;
        case 246: return _246_1.f246;
        case 1588: return _1588_1.f1588;
        case 1575: return _1575_1.f1575;
        case 1593: return _1593_1.f1593;
        case 2437: return _2437_1.f2437;
        case 35: return _35_1.f35;
        case 235: return _235_1.f235;
        case 1576: return _1576_1.f1576;
        case 227: return _227_1.f227;
        case 8211: return _8211_1.f8211;
        case 7717: return _7717_1.f7717;
        case 1072: return _1072_1.f1072;
        case 1570: return _1570_1.f1570;
        case 1583: return _1583_1.f1583;
        case 595: return _595_1.f595;
        case 1073: return _1073_1.f1073;
        case 700: return _700_1.f700;
        case 596: return _596_1.f596;
        case 4705: return _4705_1.f4705;
        case 240: return _240_1.f240;
        case 42892: return _42892_1.f42892;
        case 2476: return _2476_1.f2476;
        case 3926: return _3926_1.f3926;
        case 2348: return _2348_1.f2348;
        case 4707: return _4707_1.f4707;
        case 4709: return _4709_1.f4709;
        case 55300: return _55300_1.f55300;
        case 1085: return _1085_1.f1085;
        case 322: return _322_1.f322;
        case 8216: return _8216_1.f8216;
        case 239: return _239_1.f239;
        case 43955: return _43955_1.f43955;
        case 1705: return _1705_1.f1705;
        case 1606: return _1606_1.f1606;
        case 269: return _269_1.f269;
        case 7869: return _7869_1.f7869;
        case 252: return _252_1.f252;
        case 5312: return _5312_1.f5312;
        case 5124: return _5124_1.f5124;
        case 5130: return _5130_1.f5130;
        case 299: return _299_1.f299;
        case 1094: return _1094_1.f1094;
        case 2337: return _2337_1.f2337;
        case 4876: return _4876_1.f4876;
        case 2342: return _2342_1.f2342;
        case 1931: return _1931_1.f1931;
        case 3938: return _3938_1.f3938;
        case 233: return _233_1.f233;
        case 949: return _949_1.f949;
        case 1601: return _1601_1.f1601;
        case 55354: return _55354_1.f55354;
        case NaN: return NaN_1.fNaN;
        case 1698: return _1698_1.f1698;
        case 4877: return _4877_1.f4877;
        case 1711: return _1711_1.f1711;
        case 8225: return _8225_1.f8225;
        case 449: return _449_1.f449;
        case 450: return _450_1.f450;
        case 234: return _234_1.f234;
        case 47: return _47_1.f47;
        case 2711: return _2711_1.f2711;
        case 448: return _448_1.f448;
        case 699: return _699_1.f699;
        case 1506: return _1506_1.f1506;
        case 2361: return _2361_1.f2361;
        case 1729: return _1729_1.f1729;
        case 257: return _257_1.f257;
        case 333: return _333_1.f333;
        case 1392: return _1392_1.f1392;
        case 237: return _237_1.f237;
        case 41352: return _41352_1.f41352;
        case 7883: return _7883_1.f7883;
        case 7885: return _7885_1.f7885;
        case 5123: return _5123_1.f5123;
        case 26085: return _26085_1.f26085;
        case 232: return _232_1.f232;
        case 4325: return _4325_1.f4325;
        case 249: return _249_1.f249;
        case 3221: return _3221_1.f3221;
        case 3093: return _3093_1.f3093;
        case 6533: return _6533_1.f6533;
        case 91: return _91_1.f91;
        case 1179: return _1179_1.f1179;
        case 1090: return _1090_1.f1090;
        case 228: return _228_1.f228;
        case 6017: return _6017_1.f6017;
        case 33: return _33_1.f33;
        case 54620: return _54620_1.f54620;
        case 2325: return _2325_1.f2325;
        case 1662: return _1662_1.f1662;
        case 599: return _599_1.f599;
        case 238: return _238_1.f238;
        case 1082: return _1082_1.f1082;
        case 43274: return _43274_1.f43274;
        case 289: return _289_1.f289;
        case 487: return _487_1.f487;
        case 3939: return _3939_1.f3939;
        case 2351: return _2351_1.f2351;
        case 42209: return _42209_1.f42209;
        case 3749: return _3749_1.f3749;
        case 2354: return _2354_1.f2354;
        case 1604: return _1604_1.f1604;
        case 243: return _243_1.f243;
        case 7789: return _7789_1.f7789;
        case 2350: return _2350_1.f2350;
        case 244: return _244_1.f244;
        case 1084: return _1084_1.f1084;
        case 3374: return _3374_1.f3374;
        case 2478: return _2478_1.f2478;
        case 660: return _660_1.f660;
        case 1605: return _1605_1.f1605;
        case 4121: return _4121_1.f4121;
        case 2344: return _2344_1.f2344;
        case 451: return _451_1.f451;
        case 3588: return _3588_1.f3588;
        case 601: return _601_1.f601;
        case 2835: return _2835_1.f2835;
        case 1080: return _1080_1.f1080;
        case 7695: return _7695_1.f7695;
        case 2602: return _2602_1.f2602;
        case 2986: return _2986_1.f2986;
        case 263: return _263_1.f263;
        case 1088: return _1088_1.f1088;
        case 2360: return _2360_1.f2360;
        case 1089: return _1089_1.f1089;
        case 7269: return _7269_1.f7269;
        case 1587: return _1587_1.f1587;
        case 4656: return _4656_1.f4656;
        case 4708: return _4708_1.f4708;
        case 4873: return _4873_1.f4873;
        case 11612: return _11612_1.f11612;
        case 4124: return _4124_1.f4124;
        case 1607: return _1607_1.f1607;
        case 3523: return _3523_1.f3523;
        case 229: return _229_1.f229;
        case 297: return _297_1.f297;
        case 4840: return _4840_1.f4840;
        case 2459: return _2459_1.f2459;
        case 1827: return _1827_1.f1827;
        case 347: return _347_1.f347;
        case 2980: return _2980_1.f2980;
        case 2340: return _2340_1.f2340;
        case 6486: return _6486_1.f6486;
        case 3108: return _3108_1.f3108;
        case 3652: return _3652_1.f3652;
        case 4725: return _4725_1.f4725;
        case 417: return _417_1.f417;
        case 273: return _273_1.f273;
        case 1574: return _1574_1.f1574;
        case 1091: return _1091_1.f1091;
        case 1118: return _1118_1.f1118;
        case 42329: return _42329_1.f42329;
        case 4808: return _4808_1.f4808;
        case 2358: return _2358_1.f2358;
        case 1497: return _1497_1.f1497;
        case 31925: return _31925_1.f31925;
        case 31908: return _31908_1.f31908;
        case 20013: return _20013_1.f20013;
        case 32321: return _32321_1.f32321;
        default: return [];
    }
};
